import React, { type ReactNode } from 'react';

import type { ModalHost } from '../../model/modalHost';
import { ModalHostContext } from '../../model/modalHostContext';

interface ModalHostProviderProps {
  host: ModalHost;
  children: ReactNode;
}

export const ModalHostProvider: React.FC<ModalHostProviderProps> = ({ host, children }) => (
  <ModalHostContext.Provider value={host}>{children}</ModalHostContext.Provider>
);
